<template>
  <div class="main-box">
    <div class="top" @mouseleave.stop="handleMouseLeave">
      <div @mouseenter.stop="handleMouseEnter">
        <div class="title">
          <div class="logo-box">
            <img class="logo" src="@/assets/image/LOGO-PNG-15.png" />
            <img class="logo1" src="@/assets/image/LOGO-PNG-15.png" />
            <!-- <img class="logo1" src="@/assets/image/LOGO-PNG-12.png" /> -->
          </div>
          <div class="search-box">
            <div class="links">
              <a href="" title="">成果转化</a>
              <a href="" title="">科学普及</a>
              <a href="http://183.255.49.141:8086/wui/index.html#/?logintype=1&time=1728973225706">院内OA</a>
              <!-- &nbsp; &nbsp;| &nbsp; &nbsp; -->
              <a href="http://en.hntouybii.cn/">English</a>
            </div>
            <div class="search-input" @keyup.enter="handleSearch">
              <el-input v-model="keyWord" prefix-icon="el-icon-search" placeholder="请输入关键字"></el-input>
            </div>

            <div class="icons">
              <div class="links1">
                <a href="" title="">成果转化</a>
                <a href="" title="">科学普及</a>
              </div>
              <i class="el-icon-s-operation" @click="showMunes"></i>
            </div>

            <div class="search-input-page" v-show="isShowSearch">
              <div class="search-input-wrap">
                <div class="close-btn">
                  <i class="el-icon-close" @click="showSearch"></i>
                </div>
                <div class="search-input-box">
                  <span>请输入关键字</span>
                  <el-input class="search-el-input" v-model="keyWord" prefix-icon="el-icon-search"
                    placeholder="请输入关键字"></el-input>
                  <el-button type="primary" @click="handleSearch">搜索</el-button>
                </div>
              </div>
            </div>
            <div class="munes-page" v-show="isShowMunes">
              <div class="close-btn">
                <span>菜单列表</span>
                <i class="el-icon-close" @click="showMunes"></i>
              </div>
              <div class="munes-list">
                <el-collapse accordion>
                  <el-collapse-item :name="index" v-for="(x, index) in navArr" :key="index">
                    <div slot="title" style="flex-grow: 1;" @click="showPageOne(x.path, x)">{{ x.title }}</div>
                    <div v-if="x.children && x.children.length > 0">
                      <div class="munes-children-item" v-for="(y, ind) in x.children" :key="ind"
                        @click.stop="showPage(x.path, index, ind, x)">
                        {{ y.title }}
                      </div>
                    </div>

                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chuan-btn" @mouseenter.stop="handleMouseEnter">
        <div class=" btn-top"></div>
      </div>
      <div class="nav-box" @mouseenter.stop="handleMouseEnter">
        <div class="nav clearfix">
          <div v-for="(x, index) in navArr" :key="index" class="fl nav-btn" :class="{ 'click-bg': showSelect == index }"
            @mouseenter="mouseenter(index)" @mouseleave="mouseleave(index)" @click="showPageOne(x.path, x)">
            {{ x.title }}
            <div class="child-box" v-if="x.children && showSelect == index">
              <div class="child-list" v-for="(y, ind) in x.children" :key="ind"
                @click.stop="showPage(x.path, index, ind, x)">
                {{ y.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <router-view></router-view>
    </div>
    <div class="bottom">
      <div style="width: 100%; position: relative; z-index: 1;height: 100%;">
        <canvas id="sineCanvas" class="line"></canvas>
        <img class="bottom-img" src="../assets/image/img-18.png" alt="">
        <img class="bottom-img-2" src="../assets/image/img-18-2.png" alt="">
      </div>
      <div class="rev">
        <el-row class="bottom-main clearfix">
          <el-col :span="5" class="bottom-one fl">
            <div class="b-img">
              <img class="logo" src="@/assets/image/LOGO-PNG-11.png" />
              <!-- <img class="logo1" src="@/assets/image/LOGO-PNG-12.png" /> -->
              <img class="logo1" src="@/assets/image/LOGO-PNG-15.png" />
              <!-- <img class="logo1" src="@/assets/image/LOGO-PNG-14.png" /> -->
              <!-- <img class="logo1" src="@/assets/image/LOGO-PNG-04.png" /> -->
            </div>
          </el-col>
          <el-col :span="11" class="bottom-two fl" style="margin-top:30px;">
            <div class="b-line">
              <span class="b-line-one" @click="showPageOne('/rszp', list2)">加入我们</span>
              <span style="display: flex; justify-content: flex-start;flex-wrap: wrap;">
                <span class="n-line-two" @click="showPage('/rszp', '', 0, list2)">博士后引进招聘</span>
                <span class="n-line-two" @click="showPage('/rszp', '', 1, list2)">高层次人才招聘</span>
                <span class="n-line-two" @click="showPage('/rszp', '', 2, list2)">管理人员招聘</span>
                <span class="n-line-two" @click="showPage('/rszp', '', 3, list2)">科研助理招聘</span>
              </span>

            </div>
            <div class="b-line">
              <span class="b-line-one">联系我们</span>
              <span class="n-line-two">0898-38810583</span>
            </div>
          </el-col>
          <el-col :span="4" class="bottom-3 fl">
            <div class="top-3">友情链接</div>
            <span class="bottom-3-wrap">
              <div class="b-3"><a class="link2" href="http://edu.hainan.gov.cn/">海南省教育厅</a></div>
              <div class="b-3"><a class="link2" href="https://dost.hainan.gov.cn/">海南省科学技术厅</a></div>
              <div class="b-3"><a class="link2" href="https://www.hntou.edu.cn/">海南热带海洋学院</a></div>
            </span>
          </el-col>
          <el-col :span="4" class="bottom-4 fl">
            <div class="top-4">关注我们</div>
            <div class="code-4">
              <img src="../assets/image/Grou2p.png" style="width: 95px;height: 91px;" />
            </div>
            <div class="b-4">微信公众号</div>
          </el-col>
          <div class="b-b">
            <span>三亚市崖州区崖州湾科技城海南瑞泽办公楼6层</span><span>琼ICP备560934005号</span>
            <div>Copyright ◎2021 海南热带海洋学院崖州湾创新研究院</div>
          </div>
        </el-row>

      </div>
    </div>
  </div>
</template>
<script>
import navArr from '../api/menu';
export default {
  data() {
    return {
      whitefont: true,
      list1: {
        title: "关于我们",
        path: "/gywm",
        children: [
          {
            title: "创新院简介",
            path: "/jianjie?article_id=756081535927042048",
          },
          {
            title: "组织框架",
            path: "/zzkj?article_id=755806156456837120",
          },
          {
            title: "现任领导",
            path: "/xrld?article_id=753617779888340992",
          },
          {
            title: "发展历史",
            path: "/fzls?article_id=756083945487581184",
          },
        ]
      },
      list2: {
        title: "加入我们",
        path: "/rszp",
        children: [
          {
            title: "博士后引进招聘",
            path: "/bshyj?column_id=761227058341044224",
          },
          {
            title: "高层次人才招聘",
            path: "/gccrc?column_id=761227158329057280",
          },
          {
            title: "管理人员招聘",
            path: "/glry?column_id=761227235487473664",
          },
          {
            title: "科研助理招聘",
            path: "/kyzlzp?column_id=761227514496770048",
          },
        ]
      },
      list3: {
        title: "队伍建设",
        path: "/dwjs",
        children: [
          {
            title: "科研团队",
            path: "/kytd",
          },
          {
            title: "管理机构",
            path: "/gljg",
          },
          {
            title: "导师队伍",
            path: "/dsdw?column_id=751110310523944960",
          },
          {
            title: "博士后人才",
            path: "/bshrc?column_id=751110474995187712",
          },
          {
            title: "科研助理",
            path: "/kyzl?column_id=751110605752614912",
          },
        ]
      },

      access_token: "",
      userName: "",
      navArr: navArr,
      selectPath: "/homeIndex",
      showSelect: null,
      keyWord: "",
      isShowSearch: false,
      isShowMunes: false,
    };
  },
  computed: {
    // access_token() {
    //   return sessionStorage.getItem("access_token")
    // }
  },
  created() {
    this.$router.push({ path: "/homeIndex" });
    // let arr = JSON.stringify(this.navArr[1])
    // sessionStorage.setItem("list", arr)
    // sessionStorage.setItem("index", 0)

    window.onresize = () => {
      // this.resize()
    }
  },
  distroyed() {
    window.removeEventListener('scroll');
  },
  computed: {
    navPath() {
      return this.$route.path;
    },
  },
  mounted() {

    // 添加滚动事件监听器
    window.addEventListener('scroll', this.handleScroll);
    setTimeout(() => {
      this.drawSineCanvas()
    }, 1000);
  },
  methods: {
    drawSineCanvas() {
      var unit = 150;
      var canvas, context, canvas2, context2, height, width, xAxis, yAxis;

      canvas = document.getElementById("sineCanvas");

      context = canvas.getContext("2d");
      height = canvas.height;
      width = canvas.width;
      xAxis = Math.floor(height / 2);
      yAxis = 0;
      draw();
      function draw() {
        context.clearRect(0, 0, width, height);
        drawWave('#0457C7', .1, 3, 0);
        drawWave('#0457C7', .05, 3, 5);
        drawWave('#0457C7', .05, 8, 2);
        draw.seconds = draw.seconds + .006;
        draw.t = draw.seconds * Math.PI;
        setTimeout(draw, 35);
      };
      draw.seconds = 0;
      draw.t = 0;
      function drawWave(fillcolor, alpha, zoom, delay) {
        context.fillStyle = fillcolor;
        context.globalAlpha = alpha;

        context.beginPath();
        drawSine(draw.t / 0.5, zoom, delay);
        context.lineTo(width + 10, height);
        context.lineTo(0, height);
        context.closePath();
        context.strokeStyle = fillcolor;
        context.fill();
      }
      function drawSine(t, zoom, delay) {
        var x = t;
        var y = Math.sin(x) / zoom;
        context.moveTo(yAxis, unit * y + xAxis);
        for (var i = yAxis; i <= width + 10; i += 10) {
          x = t + (-yAxis + i) / unit / zoom;
          y = Math.sin(x - delay) / 3;
          context.lineTo(i, unit * y + xAxis);
        }
      }
    },
    handleMouseEnter() {
      let topObj = document.getElementsByClassName('top');
      topObj[0].classList.add("show_bg")
    },
    handleMouseLeave() {
      let topObj = document.getElementsByClassName('top');
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop < 30 && topObj[0]) {
        topObj[0].classList.remove("show_bg")
      }
    },
    // 定义滚动事件的处理函数
    handleScroll() {
      // 获取滚动位置
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 输出滚动位置
      var topObj = document.getElementsByClassName('top');
      if (topObj[0]) {
        if (scrollTop > 30) {
          topObj[0].classList.add("show_bg")
        } else {
          topObj[0].classList.remove("show_bg")
        }
      }
    },

    showPage(path, i, ind, list) {
      // if (this.selectPath == path) return;
      this.selectPath = path;
      // this.showSelect = i;


      let arr = JSON.stringify(list)
      sessionStorage.setItem("list", arr)
      sessionStorage.setItem("index", ind)
      this.$router.push({ path: path });
      this.showSelect = null
      if (this.isShowMunes) {
        this.isShowMunes = false
      }

    },
    showPageOne(path, list) {
      if (path == "/homeIndex") {
        this.$router.push({ path: "/homeIndex" });
      } else {
        this.showPage(path, 0, 0, list)
      }

    },
    mouseenter(index) {
      this.showSelect = index
      setTimeout(() => {
        // todo 船动画
        let navBtnObj = document.getElementsByClassName('fl nav-btn');
        let selectObj = document.getElementsByClassName('click-bg');
        let btnTopObj = document.getElementsByClassName('btn-top');
        // 获取该元素的位置信息
        var rect = selectObj && selectObj.length > 0 ? selectObj[0].getBoundingClientRect() : {};
        var first = navBtnObj[0].getBoundingClientRect();

        // 打印位置信息
        let x = rect.left - first.left;
        btnTopObj[0].style.transform = `translateX(${x}px)`;

      }, 500);

    },
    mouseleave(index) {
      this.showSelect = null
    },
    goNewPage(url) {
      window.open(url, 'target', '')
    },
    handleSearch(val) {
      if (this.keyWord == "") return
      this.$router.push({
        path: "/searchPage",
        query: {
          article_title: this.keyWord
        }
      })
    },
    showSearch() {
      this.isShowSearch = !this.isShowSearch

    },
    showMunes() {
      this.isShowMunes = !this.isShowMunes
    },


  },
};
</script>
<style lang="less" scoped>
.main-box {
  margin: 0;
  padding: 0;
  position: relative;
}

.top {
  &.show_bg {
    background-color: #0066b4;
  }

  .title {
    position: relative;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;

    .logo-box {
      flex-grow: 1;
    }

    .logo,
    .logo1 {
      height: 70px;
    }

    // padding-top: 30px;
    .title-front {
      margin-top: 40px;
      margin-left: 10px;

      .fron-one {
        font-size: 20px;
        font-weight: 600;
        line-height: 40px;
      }

      .fron-two {
        font-size: 14px;
      }
    }

    .search-box {
      display: flex;
      align-items: center;
      // position: relative;

      .links,
      .links1 {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        a {
          margin: 5px 0;
          padding: 0 10px;
          flex-grow: 1;
          text-align: center;
          text-decoration: none;
          color: #fff;
          border-right: solid 1px #fff;
          line-height: 1;

          &:last-child {
            border-right: none;
          }
        }
      }

      .search-input {
        padding-left: 20px;
      }

      .icons {
        display: flex;
        font-size: 28px;
        color: #fff;
        align-items: center;
      }

      .search-input-page {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 3;
        background-color: rgba(255, 255, 255, 0.8);

        .close-btn {
          padding: 30px;
          text-align: right;
        }

        .el-icon-close {
          font-size: 36px;
          font-weight: 700;
        }

        .search-input-wrap {
          background-color: #fff;
          height: 400px;
          position: relative;

          &:after {
            content: " ";
            width: 100%;
            height: 80px;
            position: absolute;
            bottom: -80px;
            background-image: linear-gradient(#fff, transparent);
          }
        }

        .search-input-box {
          text-align: center;
          width: 100%;

          span {
            display: block;
            padding-bottom: 30px;
            font-size: 32px;
            color: #0066b4;
          }

          .search-el-input {
            margin-top: 50px;
            display: inline-block;
            width: 300px;
          }

          .el-button--primary {
            background-color: #0066b4;
            border-color: #0066b4;
          }
        }
      }

      .munes-page {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 3;
        background-color: #fff;

        .close-btn {
          padding: 30px 30px 0;
          text-align: right;

          span {
            display: inline-block;
            font-size: 32px;
            color: #0066b4;
            width: 90%;
            text-align: center;
          }
        }

        .el-icon-close {
          font-size: 28px;
          color: #999;
        }

        .munes-list {
          padding: 20px;

          .munes-children-item {
            padding-left: 20px;
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            font-weight: lighter;
          }
        }
      }
    }

    .link2 {
      position: absolute;
      right: 0;
      top: 15px;
      color: #333333;
      text-decoration: none
    }
  }
}

.middle {
  height: auto;
  position: relative;
  z-index: 0;
  // min-height: 800px;
  // margin-bottom: 40px;
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 560px;

  overflow: hidden;

  .rev {
    width: 100%;
    position: absolute;
    bottom: 20px;
    height: 220px;

    .bg-image {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;

      img {
        width: 100%;
        height: 220px;
      }
    }


    .bottom-main {
      position: relative;
      box-sizing: border-box;
      z-index: 1;
      width: 100%;
      color: white;
      margin: 0 auto;
      text-align: center;
      padding: 0 50px;
      padding-top: 20px;
      height: 220px;
      overflow: hidden;

      .bottom-one {
        margin-top: 20px;

        img {
          height: 120px;
        }

        .fron-one {
          font-size: 20px;
        }

        .fron-two {
          font-size: 9px;
        }
      }

      .bottom-two {
        // width: 300px;
        // margin: 0 50px;

        .b-line {
          text-align: left;
          margin: 20px 0;
          display: flex;
          justify-content: start;

          .b-line-one {
            font-size: 16px;
            font-weight: 600;
            margin-right: 20px;
            padding-right: 20px;
            display: inline-block;
            border-right: 2px solid white;
            cursor: pointer;
            flex-shrink: 0;
          }

          .n-line-two {
            flex-grow: 1;
            cursor: pointer;
            width: 8em;
            // margin: 0 20px;
          }
        }
      }

      .bottom-3 {
        // margin: 0 50px;

        .top-3 {
          font-size: 16px;
          font-weight: 600;
        }

        .b-3 {
          margin: 20px 0;

          a {
            text-decoration: none;
            color: #fff;
          }
        }
      }

      .bottom-4 {
        .top-4 {
          font-size: 16px;
          margin: 0 0 10px 0;
        }
      }

      .b-b {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 10px;
        text-align: center;
      }
    }


  }
}


.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  line-height: 0;
  clear: both;
  visibility: hidden;
}

.nav-box {
  width: 100%;
  height: 40px;
  z-index: 1;
  position: relative;
  font-weight: bold;
  // background: #0068b4;

  .nav {
    width: 1460px;
    height: 40px;
    margin: 0 auto;

    .nav-btn {
      width: 160px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: white;
      // background: #0068b4;
      text-align: center;
      cursor: pointer;
      position: relative;

      // &:hover{
      //   background: #009fd9;
      // }


      .child-box {
        position: absolute;
        width: 160px;
        top: 40px;
        z-index: 1;
        background: #009fd9;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
        white-space: nowrap;
      }

      .child-list:hover {
        background: #0db6f3;
        // background: #5e9fe3;
      }
    }

    .nav-btn:last-child{
      width: 180px;
      .child-box{
        width: 180px;
        .child-list:last-child{
          width: 180px;
        }
      }
    }

    .nav-btn:hover {
      background: #0db6f3;
      // background: #5e9fe3;
    }

    .click-bg {
      background: #009fd9;

      // background: #5e9fe3;
    }
  }
}

.chuan-btn {
  height: 15px;
  width: 1460px;
  margin: 0 auto;
  position: relative;

  .btn-top {
    background-image: url('../assets/image/chuan-white.png');
    background-repeat: no-repeat;
    background-position: 38px 1px;
    transition: transform 1.5s ease;
    height: 30px;
    width: 160px;
    z-index: 2;
    position: absolute;
    top: -15px;
  }
}



.fontover {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

div {
  transition: all 0.3s;
}

.link:hover {
  color: #0457C7 !important;
  cursor: pointer;
}

canvas.line {
  height: 230px;
  width: 1930px;
  position: absolute;
  left: 50%;
  top: 200px;
  transform: translateX(-50%);
  z-index: -2;
}

.bottom-img, .bottom-img-2 {
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: -1;
}

@media screen and (min-width: 1025px) {
  .top {
    position: fixed;
    top: 0;
    z-index: 15;
    width: 100%;
    height: 140px;
  }

  .main-box {
    overflow-x: hidden;
    min-width: 1460px;

    .bottom {
      min-width: 1460px;
    }
  }

  .title {
    width: 1460px;

    .logo {

      display: block;
    }

    .logo1 {
      display: none;
    }
  }

  .links {
    // width: 240px;
  }

  .icons {
    display: none !important;
  }

  .search-input {
    display: block;
  }

  .nav-box {
    .nav {
      width: 1460px;
    }
  }

  .bottom-img {
    display: block;
    min-width: 1460px;
  }

  .bottom-img-2 {
    display: none;
  }

  .bottom .rev .bottom-main {
    padding-top: 45px;
  }

  .bottom-one {
    .logo {
      display: block;
    }

    .logo1 {
      display: none;
    }
  }
}

@media screen and (max-width: 1025px) {

  html {
    overflow-x: hidden;
  }

  div {
    box-sizing: border-box;
  }

  .fl {
    float: none;
  }

  .top {
    position: fixed;
    z-index: 15;
    width: 100%;
    background-color: #0066b4;
    padding: 0 10px;
  }

  .title {
    width: 100%;
    padding: 15px 0;

    .logo {
      display: none;
    }

    .logo1 {
      display: block;
      height: 35px !important;
    }
  }

  .search-box {
    align-items: flex-end !important;
  }

  .links {
    display: none !important;
  }

  .links1 {
    display: flex;
    flex-wrap: nowrap;
    font-size: 11px;
    padding-right: 10px;
    align-items: flex-end;

    a {
      border-right: none !important;
    }
  }

  .search-input {
    display: none;
  }

  .icons {
    display: block;
  }

  .nav-box {
    display: none;
  }

  .chuan-btn {
    display: none;
  }

  .middle {
    // bottom: 620px;
    padding-top: 65px;
    min-height: 100vh;
  }

  canvas.line {
    width: 100%;
    height: 100px;
    top: 0;
  }

  .bottom {
    position: relative;
    height: 420px;
    .bottom-img {
      display: none;
      top: 0;
    }

    .bottom-img-2 {
      display: block;
      top: 0;
    }

    .rev {
      width: 100%;
      top: 70px;
      height: 100%;
      padding: 0 0 20px;

      .bottom-main {
        padding: 0 20px;
        height: 100%;

        .bottom-one {
          width: 100%;
          margin-top: 0;
        }

        .b-img {
          width: 100%;
          margin: 0 auto;

          .logo {
            display: none;
          }

          .logo1 {
            display: block;
            width: 100%;
            height: auto;
            object-fit: contain;
          }
        }

        .bottom-two,
        .bottom-3,
        .bottom-4 {
          width: 100%;

        }

        .bottom-two {
          width: 60%;
        }

        .b-line {
          width: 60%;
          align-items: center;
          margin: 10px 0 !important;

          .b-line-one {
            margin-right: 10px !important;
            padding-right: 10px !important;
          }

          .n-line-two {
            text-align: left;
            flex-grow: 0 !important;
            padding: 5px 0;
            text-wrap: nowrap;
          }
        }

        .bottom-3 {
          display: none;
          // display: flex;
          // margin-bottom: 10px;
          // align-items: center;

          // .top-3 {
          //   flex-shrink: 0;
          //   margin-right: 10px;
          //   padding-right: 10px;
          //   display: inline-block;
          //   border-right: 2px solid white;
          // }

          // .bottom-3-wrap {
          //   display: flex;
          //   justify-content: flex-start;
          //   flex-wrap: wrap;
          // }

          // .b-3 {
          //   margin: 0;
          //   width: 8em;
          //   text-align: left;
          //   padding: 5px 0;
          // }
        }

        .bottom-4 {
          position: absolute;
          top: 90px;
          right: 0;
          width: 40%;
        }

        .b-b {
          margin-top: 10px;
          position: relative !important;
          left: unset;
          transform: unset;
          bottom: unset;

          span {
            display: block;
          }
        }
      }


    }
  }

  /deep/ .munes-children-item {
    font-weight: unset !important;
  }

  /deep/ .el-icon-arrow-right {
    width: 40px;
    text-align: right;
  }
}

@media screen and (max-width: 750px) {
  .rev {
    background: #023e9b;

  }
}
</style>